module.exports = __webpack_public_path__ + "static/media/icon-long-arrow-left-blue.163e5f6d.svg";